import { useTranslation } from 'react-i18next';

const FamilyBuildingSurrogacyJourney = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="surrogacy-journey-label">Surrogacy Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Where are you in your surrogacy journey?</h3>
        
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney1"
            value="Exploring Options"
            checked={formData.SurrogacyJourney === "Exploring Options"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney1" className="multistep-form-radio-checkbox-label">Exploring Options</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney2"
            value="Selecting an agency"
            checked={formData.SurrogacyJourney === "Selecting an agency"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney2" className="multistep-form-radio-checkbox-label">Selecting an agency</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney3"
            value="Working with an agency"
            checked={formData.SurrogacyJourney === "Working with an agency"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney3" className="multistep-form-radio-checkbox-label">Working with an agency</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney4"
            value="Matched with a gestational carrier"
            checked={formData.SurrogacyJourney === "Matched with a gestational carrier"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney4" className="multistep-form-radio-checkbox-label">Matched with a gestational carrier</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney5"
            value="Currently in cycle/pregnant"
            checked={formData.SurrogacyJourney === "Currently in cycle/pregnant"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney5" className="multistep-form-radio-checkbox-label">Currently in cycle/pregnant</label>
        </div>
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyJourney"
            id="surrogacyJourney6"
            value="Post-birth"
            checked={formData.SurrogacyJourney === "Post-birth"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyJourney6" className="multistep-form-radio-checkbox-label">Post-birth</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
    {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingSurrogacyJourney;
